export class InFocus {
  value = false;
}
